import { render, staticRenderFns } from "./KikiCard.vue?vue&type=template&id=4fccfc71&"
import script from "./KikiCard.vue?vue&type=script&lang=js&"
export * from "./KikiCard.vue?vue&type=script&lang=js&"
import style0 from "./KikiCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports